const logs = {};

function request(reflexId, target, args, stimulusControllerIdentifier, element) {
  logs[reflexId] = new Date();
  console.log(`\u2191 stimulus \u2191 ${target}`, {
    reflexId,
    args,
    stimulusControllerIdentifier,
    element
  });
}

function success(response, options = {
  halted: false
}) {
  const event = response.event;

  const _ref = event.detail.stimulusReflex || {},
        reflexId = _ref.reflexId,
        target = _ref.target,
        broadcaster = _ref.broadcaster;

  console.log(`\u2193 reflex \u2193 ${target}`, {
    reflexId,
    duration: `${new Date() - logs[reflexId]}ms`,
    halted: options.halted,
    broadcaster
  });
  delete logs[reflexId];
}

function error(response) {
  const _ref2 = response || {},
        event = _ref2.event,
        element = _ref2.element;

  const _ref3 = event || {},
        detail = _ref3.detail;

  const _ref4 = detail.stimulusReflex || {},
        reflexId = _ref4.reflexId,
        target = _ref4.target,
        error = _ref4.error,
        broadcaster = _ref4.broadcaster;

  console.error(`\u2193 reflex \u2193 ${target}`, {
    reflexId,
    duration: `${new Date() - logs[reflexId]}ms`,
    error,
    broadcaster,
    payload: event.detail.stimulusReflex,
    element
  });
  if (detail.stimulusReflex.serverMessage.body) console.error(`\u2193 reflex \u2193 ${target}`, detail.stimulusReflex.serverMessage.body);
  delete logs[reflexId];
}

export default {
  request,
  success,
  error
};